/* =================== SLIDE HOME =================== */
jQuery(document).ready(function($){
  $('.slide-home')
  .on('init', function() {
    $('.slide-content').show();
  })
  .slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    fade: true, 
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 760,
        settings: {
          arrows: false
        }
      }
    ]
  })
  .on('beforeChange', function() {
    $('.slide-content').hide();
  })
  .on('afterChange', function() {
    $('.slide-content').show();
  });
});
